/**
 * Miniatura de documento no carrossel de anexo.
 * Mobile-first; remoção com tokens do design system (sem badge destruído flutuante).
 */
import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import { cn } from '@/lib/utils';

interface ChatDocChipProps {
    file: File;
    isActive?: boolean;
    onSelect?: () => void;
    onRemove: () => void;
}

function fileExtLabel(file: File): string {
    const ext = file.name.includes('.')
        ? file.name.split('.').pop()?.toUpperCase()
        : '';
    return ext && ext.length <= 5 ? ext : 'DOC';
}

export const ChatDocChip: React.FC<ChatDocChipProps> = ({
    file,
    isActive = false,
    onSelect,
    onRemove,
}) => (
    <article
        className={cn(
            'group relative size-14 shrink-0 overflow-hidden rounded-lg border bg-surface-subtle sm:size-16',
            isActive ? 'border-primary' : 'border-subtle'
        )}
        aria-current={isActive ? 'true' : undefined}
    >
        <button
            type="button"
            onClick={onSelect}
            className="flex size-full flex-col items-center justify-center gap-0.5 px-1 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/20"
            aria-pressed={isActive}
            aria-label={`Selecionar ${file.name}`}
        >
            <AppIcon name="file-text" className="size-4 text-destructive sm:size-5" aria-hidden />
            <span className="w-full truncate text-center text-caption font-medium text-muted">
                {fileExtLabel(file)}
            </span>
        </button>
        <button
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                onRemove();
            }}
            className={cn(
                'absolute right-0.5 top-0.5 flex size-6 items-center justify-center rounded-md',
                'bg-card/90 text-muted backdrop-blur-sm',
                'transition-colors hover:bg-surface-subtle hover:text-destructive',
                'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/20',
                'sm:opacity-0 sm:group-hover:opacity-100 sm:group-focus-within:opacity-100'
            )}
            aria-label={`Remover ${file.name}`}
        >
            <AppIcon name="x" className="size-3.5" aria-hidden />
        </button>
    </article>
);
